/*====== import  ======*/
/*------ React ------*/
import React, { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import { useMsal } from "@azure/msal-react";
import { AUTHORITY_STORAGE, CODEDIFINITION_STORAGE, YEAR_STORAGE, screenMaster } from "03CommonApiParts/CodeDefinition";
/*------ CSS ------*/
// import styled from 'styled-components';
/*------ Component Js/Jsx ------*/
import { SnackBar } from "02CommonUiParts/MessageParts/SnackBar";
import { USERINFO_STORAGE, AUTH_TOKEN, PUBLIC_KEY } from "03CommonApiParts/CodeDefinition";
import { useProvideData } from "03CommonApiParts/use-context";
import { LoadingProgressBar } from "02CommonUiParts/OtherParts/LoadingProgressBar";
import { Dialog } from "02CommonUiParts/MessageParts/Dialog";
import { CFStringDecodeJP } from "03CommonApiParts/CommonFunction";
/*====== Styles  ======*/
/*------ Styled Components ------*/

/*====== global variables ======*/
const base64Swicth = true;	//エンコードデコード制御用
/*====== global functions ======*/


/* --------------------------- */
/* ---------- main ---------- */
/* --------------------------- */
export const GetAuth02 = () =>{ //GraphAPI　ユーザー情報取得
    /* --------------------------- */
    /* -------- instance  -------- */
    /* --------------------------- */
    const navigate = useNavigate();//画面遷移用
    const apiData = useProvideData();	//APIデータ取得
    const { instance, accounts } = useMsal();
    /* --------------------------- */
    /* ---------- state ---------- */
    /* --------------------------- */
    const [snackbarMessage, setSnackbarMessage] = useState({ //スナックバー表示用
        open:false,
    });
    const [dialogMessage, setDialogMessage] = useState({ //ダイアログ表示用
        open:false,
    })
    const [progress, setProgress] = useState(false); //プログレスバー表示用
    /* --------------------------- */
    /* -------- variables -------- */
    /* --------------------------- */

    /* --------------------------- */
    /* -------- functions -------- */
    /* --------------------------- */
    useEffect(()=>{
        getPublicKey();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const getPublicKey = async () => {
        /* 処理が何度も走らないように制御 */
        if(progress) return;
        /* プログレスバー表示 */
        setProgress(true);
        /* リクエスト */
        const handlingInformation = {};
        const key = {};
        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = accounts[0].username; 
        handlingInformation.hndEmpFullName = null;
        handlingInformation.sreId = 'GetAuth';
        handlingInformation.hndId = 'GET';
        /* キー */
        key.mailAdrs = accounts[0].username;

        /* リクエスト先 */
        const apiPath = '/common/getpublickey';	//API Path

        /* リクエストパラメータ */
        const apiBody = { handlingInformation: handlingInformation, key: key };

        /* API処理開始 */
        await apiData.getDataPost(apiPath, apiBody, (result) => {
            if (result.isSuccessed) {
                const data = result.responseData.data;
                let decrypted = Buffer.from(data, 'base64').toString();
                sessionStorage.setItem(PUBLIC_KEY,JSON.stringify(decrypted));
                getAuthToken();
            }else{//APIリクエスト結果 = 異常
                /* プログレスバー非表示 */
                setProgress(false);
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                });
            };
        });
    }

    const getAuthToken = async() =>{
        /* 処理が何度も走らないように制御 */
        if(progress) return;
        /* プログレスバー表示 */
        setProgress(true);
        /* リクエスト */
        const handlingInformation = {};
        const key = {};
        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = accounts[0].username; 
        handlingInformation.hndEmpFullName = null;
        handlingInformation.sreId = 'GetAuth';
        handlingInformation.hndId = 'GET';
        /* キー */
        key.mailAdrs = accounts[0].username;

        /* リクエスト先 */
        const apiPath = '/authorization/getauthorizationtoken';	//API Path
        
        /* リクエストパラメータ */
        const apiBody = { handlingInformation: handlingInformation, key: key };

        /* API処理開始 */
        await apiData.getDataPost(apiPath, apiBody, (result) => {
            if(result.isSuccessed) {
                const data = JSON.parse(result.responseData.data).encryptedToken;
                sessionStorage.setItem(AUTH_TOKEN,JSON.stringify(data));
                getData();
            }else{//APIリクエスト結果 = 異常
                /* プログレスバー非表示 */
                setProgress(false);
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                });
                
            };
        });
    };

    const getData = async() =>{
        /* 処理が何度も走らないように制御 */
        if(progress) return;
        /* プログレスバー表示 */
        setProgress(true);
        /* リクエスト */
        const handlingInformation = {};
        const key = {};
        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = accounts[0].username;
        handlingInformation.hndEmpFullName = null;
        handlingInformation.sreId = 'GetAuth';
        handlingInformation.hndId = 'GET';
        /* キー */
        key.mailAdrs = accounts[0].username;

        /* リクエスト先 */
        const apiPath = '/authorization/getauthorization';	//API Path
        
        /* リクエストパラメータ */
        const apiBody = { handlingInformation: handlingInformation, key: key };

        /* API処理開始 */
        await apiData.getDataPost(apiPath, apiBody, (result) => {
            if (result.isSuccessed) {//APIリクエスト結果 = 正常
                const data = result.responseData.data.payload[0];
                var empInfo = data.empInfo;
                Object.keys(empInfo).forEach((item)=>{
                    empInfo[item] = empInfo[item] ? CFStringDecodeJP(empInfo[item],base64Swicth) : null;
                });

                /* USERINFO_STORAGEにユーザー情報の保存 */
                sessionStorage.setItem(USERINFO_STORAGE,JSON.stringify({...empInfo,mail:accounts[0].username}));
                /* AUTHORITY_STORAGEに権限の保存 */
                sessionStorage.setItem(AUTHORITY_STORAGE,JSON.stringify(data.assignementAuthorityList));
                /* コード定義のデコード処理　*/
                const codeDefinitionList = [];
                data.codeDefinitionList.forEach((item)=>{
                    const object = {};
                    const list = [];
                    item.list.forEach((element)=>{
                        list.push({
                            value:element.value,
                            label:CFStringDecodeJP(element.label,base64Swicth)
                        });
                    })
                    object.code = item.code;
                    object.name = CFStringDecodeJP(item.name,base64Swicth);
                    object.list = list;
                    codeDefinitionList.push(object);
                })
                /* CODEDIFINITION_STORAGEにコード定義の保存 */
                sessionStorage.setItem(CODEDIFINITION_STORAGE,JSON.stringify(codeDefinitionList));
                /* YEAR_STORAGEに年度リストの保存 */
                const editYearList = [];
                data.yearList.forEach((item)=>{
                    editYearList.push({
                        label:CFStringDecodeJP(item.yearItemLabel,base64Swicth),
                        value:item.yearItemValue
                    })
                });
                
                sessionStorage.setItem(YEAR_STORAGE,JSON.stringify(editYearList));

                const displayScreenInfoList = data.assignementAuthorityList // 画面コードマスタから表示権限な画面のみを抽出した配列を作る
                    .filter(item => item.authSubCtgrCdList.includes('menuDisplay'))
                    .map(item => screenMaster.find(smItem => (
                        smItem.auth === item.authMinCtgrCd
                        && smItem.path.split('/').slice(-1).includes('list') // pathの末尾がlistのものを取得する
                    )))
                    .filter(Boolean) // エラー防止のためundefined,nullの項目は除去する

                /* 従業員の権限があれば従業員一覧へ遷移 */
                if (displayScreenInfoList.find(item => item.auth === 'information')) {
                    navigate('/employee/information/list')
                } else {
                /* 無ければ権限リストの１番目の一覧へ遷移 */
                    navigate(displayScreenInfoList[0]?.path)
                }

            }else{//APIリクエスト結果 = 異常
                /* プログレスバー非表示 */
                setProgress(false);
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                });
                
            };
            
        });
    };

    /*------ ダイアログOKボタン押下後の処理 ------*/
    const onClickDialogOK = () =>{
        /* サインアウト処理 */
        instance.logoutRedirect({
            postLogoutRedirectUri: "/",
        });
    };
      
    /* --------------------------- */
    /* ---------- data ----------- */
    /* --------------------------- */
	
    
    return(
        <>
            {/* プログレスバー */}
            <LoadingProgressBar open={progress}/>
            {/* スナックバー */}
            <SnackBar
                content={snackbarMessage}
                set={setSnackbarMessage}/> 
            {/* ダイアログ */}
            <Dialog
				content={dialogMessage}
				set={setDialogMessage}
				onClickOK={onClickDialogOK}
			/> 
        </>
    );
};
